var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('v-alert',{attrs:{"color":"primary","text":""},domProps:{"innerHTML":_vm._s(_vm.content.html)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }